import inicioResumen from './Resumen/resumenCtrl';
import poliza from './Poliza/polizaCtrl';
import poliza_nueva from './Poliza/polizaNuevaCtrl';
import poliza_duplicar from './Poliza/polizaDuplicarCtrl';
import poliza_ver from './Poliza/polizaVerCtrl';
import mejores_precios from './MejorasPrecios/MejorasPrecios';
import confirmacion from './MejorasPrecios/Confirmacion';

export default angular.module('contartemx.inicio', [
    inicioResumen.name,
    'contartemx.inicio.poliza',
    'contartemx.inicio.poliza.nueva',
    'contartemx.inicio.poliza.duplicar',
    'contartemx.inicio.poliza.ver_poliza',
    'contartemx.inicio.mejoras_precios',
    'contartemx.inicio.confirmacion',
    'ui.router'
])
    .config(($stateProvider) => {
        $stateProvider.state('inicio', {
            url: '/Inicio',
            abstract: true,
            views: {
                'submenu': {
                    template: require('../../../../app/views/Inicio/Inicio_submenu.html'),
                    controller: 'InicioCtrl'
                },
                '': {
                    template: require(`../../../../app/views/MainContainer.html`)
                }
            },
            resolve: {
                authorize: ['authorization', authorization => authorization.authorize()],
            }
        })
            .state('inicio.resumen', {
                url: '/Resumen',
                views:
                {
                    'main': {
                        template: require(`../../../../app/views/Inicio/Resumen/Resumen_main.html`),
                        controller: 'ResumenCtrl'
                    }
                }
            })
            .state('inicio.poliza', {
                url: '/Polizas',
                views:
                {
                    'main': {
                        template: require(`../../../../app/views/Inicio/Poliza/Poliza_main.html`),
                        controller: 'PolizaCtrl'
                    }
                },
                data: { roles: ['Contabilidad_Polizas'] }
            })
            .state('inicio.poliza.nueva', {
                url: '/Nueva',
                views:
                {
                    'main@inicio': {
                        template: require(`../../../../app/views/Inicio/Poliza/Nueva/Poliza_main.html`),
                        controller: 'PolizaNuevaCtrl'
                    }
                },
                data: { roles: ['Contabilidad_Polizas'] }
            })
            .state('inicio.poliza.ver_poliza', {
                url: '/:num_pol',
                views:
                {
                    'main@inicio': {
                        template: require(`../../../../app/views/Inicio/Poliza/Ver/Poliza_main.html`),
                        controller: 'PolizaVerCtrl'
                    }
                },
                data: { roles: ['Contabilidad_Polizas'] }
            })
            .state('inicio.poliza.duplicar', {
                url: '/Duplicar/:num_pol',
                views:
                {
                    'main@inicio': {
                        template: require(`../../../../app/views/Inicio/Poliza/Duplicar/Poliza_main.html`),
                        controller: 'PolizaDuplicarCtrl'
                    }
                },
                data: { roles: ['Contabilidad_Polizas'] }
            })
            .state('inicio.mejoras_precios', {
                url: '/MejorasPrecios/:default',
                views: {
                    'main': {
                        template: require(`../../../../app/views/Inicio/MejorasPrecios/MejorasPrecios_main.html`),
                        controller: 'MejorasPreciosCtrl'
                    }
                },
                data: { roles: ['Administracion_Cuentas'] },
                redirectTo: 'administracion.cuentas'
            })
            .state('inicio.datos_compra', {
                url: '/DatosCompra?referenceCode&status',
                views: {
                    'main': {
                        template: require(`../../../../app/views/Inicio/MejorasPrecios/DatosDeCompra.html`),
                        controller: 'DatosCompraCtrl'
                    }
                },
                data: { roles: ['Administracion_Cuentas'] }
            })
            .state('inicio.confirmacion', {
                url: '/Confirmacion/:referenceCode/:paymentType',
                views: {
                    'main@inicio': {
                        template: require(`../../../../app/views/Inicio/MejorasPrecios/ConfirmarCompra.html`),
                        controller: 'ConfirmacionCtrl'
                    }
                },
                data: { roles: ['Administracion_Cuentas'] }
            });
    })
    .controller('InicioCtrl', ($scope, $state, callToWebService, mostrarNotificacion) => {

        $scope.loading = false;

        $scope.pasoOnboardPref = function () {
            $scope.loading = true;
            $scope.$emit('nextOnboardingStep');
        };

        $scope.$on("EnableOnboarding", function () {
            $scope.loading = false;
        });

    });
